import React, { useState } from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
} from 'recharts';

type DataPoint = {
  month: string;
  visitors: number;
  pageViews: number;
};

const initialData: DataPoint[] = [
  { month: 'Jan', visitors: 80, pageViews: 95 },
  { month: 'Feb', visitors: 70, pageViews: 100 },
  { month: 'Mar', visitors: 120, pageViews: 140 },
  { month: 'Apr', visitors: 180, pageViews: 190 },
  { month: 'May', visitors: 90, pageViews: 150 },
  { month: 'Jun', visitors: 100, pageViews: 130 },
  { month: 'Jul', visitors: 105, pageViews: 120 },
];

const Chart: React.FC = () => {
  const [view, setView] = useState<'Day' | 'Month' | 'Year'>('Month');
  const [data] = useState<DataPoint[]>(initialData);

  return (
    <div className="p-6 mt-8 bg-white rounded-lg shadow">
      {/* ヘッダー */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-semibold">レポートグラフ</h2>
          <p className="text-sm text-gray-500">2023年1月 – 7月</p>
        </div>
        {/* ビュー切り替えボタン */}
        <div className="space-x-2">
          {(['Day', 'Month', 'Year'] as const).map((mode) => (
            <button
              key={mode}
              onClick={() => setView(mode)}
              className={`px-3 py-1 rounded ${
                view === mode
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
              type="button"
            >
              {mode}
            </button>
          ))}
        </div>
      </div>

      {/* チャート */}
      <div className="w-full h-64">
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorVisitors" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.4}/>
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="month" tick={{ fill: '#9ca3af' }} />
            <YAxis tick={{ fill: '#9ca3af' }} />
            <Tooltip 
              wrapperClassName="bg-white shadow rounded" 
              contentStyle={{ border: 'none' }} 
            />
            {/* 閾値の破線 */}
            <ReferenceLine y={80} stroke="#ef4444" strokeDasharray="5 5" />
            {/* 面グラフ */}
            <Area
              type="monotone"
              dataKey="visitors"
              stroke="#3b82f6"
              fill="url(#colorVisitors)"
              dot={false}
            />
            {/* 緑の折れ線 */}
            <Line
              type="monotone"
              dataKey="pageViews"
              stroke="#10b981"
              strokeWidth={2}
              dot={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Chart;
